import React from 'react';

/**
 * Diagnoses Heading component
 */
const DiagnosesHeadingOutput = (props) => (
  <div>
    <h2>{props.data.label}    <a href="#" aria-label={props.data.aria}>
        <div className="nppe2-fc-info-button"
        onClick={ (e) => {
          props.openModalWithContent("ClinicalDiagnosesCriticalCare");
          e.preventDefault();
        }}></div>
      </a></h2>

    <p>{props.data.description}</p>
  </div>
);

export default DiagnosesHeadingOutput;
